// extracted by mini-css-extract-plugin
export default {"svg":"ImageStepThird_svg__IOaex"};